import React, { useState } from "react";
import { toast } from "react-toastify";
import { Input, Popup } from "semantic-ui-react";
import { validateAppstoreToken, storeAppstoreToken } from "../../../../../actions/authAction";
import Modal from "../../../../UIComponents/CustomModal/Modal";
import "./AppstoreCredentialModal.scss";
import Loader from "semantic-ui-react/dist/es/elements/Loader/Loader";
import { ReactComponent as InfoIcon } from "../../../../../assets/svg/info-icon.svg";

const AppstoreCredentialModal = ({ hideModal, fetchToken }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [key, setKey] = useState("");
    const [issuerId, setIssuerId] = useState("");
    const [privateKey, setPrivateKey] = useState("");

    const handleSave = async () => {
        if (key.trim() == "") {
            toast.error("Please enter your App Store Key");
            return;
        }

        if (issuerId.trim() == "") {
            toast.error("Please enter your Issuer Id");
            return;
        }
        if (privateKey.trim() == "") {
            toast.error("Please enter your Private Key");
            return;
        }
        setIsLoading(true);

        const obj = {
            key_id: key.trim(),
            issuer_id: issuerId.trim(),
            private_key: privateKey,
        };

        const data = await validateAppstoreToken(obj);
        console.log("validatePlaystoreToken", data);
        if (data?.status === "success") {
            const params = {
                scopes: ["appstoreconnect-v1"],
                token_source: "app",
                apps_to_add: [
                    {
                        ...obj,
                    },
                ],
                apps_to_remove: [],
            };

            await storeAppstoreToken(params);
        } else {
            toast.error("Invalid credentials");
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        fetchToken();

        hideModal();
    };

    return (
        <Modal className={`canned-block`} show onClose={hideModal}>
            <Modal.Header className="appstore__heading">
                App Store
                <Popup
                    className="infoPopup skiptranslate"
                    position="bottom center"
                    size="mini"
                    content="Please make sure to provide admin private key and not the developer private key. By providing developer private key, you cannot reply to the reviews. Also, it might take upto 24 - 48 hours to fetch App Store reviews."
                    trigger={
                        <div className="info-icon" data-html2canvas-ignore="true">
                            <InfoIcon className="info__icon" />
                        </div>
                    }
                    // open
                    style={{ zIndex: "99999999" }}
                />
            </Modal.Header>
            <Modal.Content className="canned-block-container">
                <div className="category-conatiner">
                    <p>Please enter your App Store Key</p>
                </div>
                <div className="canned-block-title-input ">
                    <Input className="field" placeholder="Key" type="text" onChange={(e) => setKey(e.target.value)} value={key} required />
                </div>
                <div className="category-conatiner">
                    <p>Please enter your Issuer Id</p>
                </div>
                <div className="canned-block-title-input ">
                    <Input value={issuerId} type="text" className="field" placeholder="Issuer Id" onChange={(e) => setIssuerId(e.target.value)} required />
                </div>
                <div className="category-conatiner">
                    <p>Please enter your Private Key</p>
                </div>
                <textarea
                    rows="5"
                    className="text__area__input"
                    placeholder="Private Key"
                    value={privateKey}
                    onChange={(e) => {
                        setPrivateKey(e.target.value);
                    }}></textarea>
            </Modal.Content>
            <Modal.Actions>
                <Modal.ActionButton normal onClick={hideModal}>
                    Cancel
                </Modal.ActionButton>
                <Modal.ActionButton className="appstore__action__button" disabled={isLoading} filled onClick={handleSave}>
                    {isLoading ? <Loader active /> : null}
                    Save
                </Modal.ActionButton>
            </Modal.Actions>
        </Modal>
    );
};

export default AppstoreCredentialModal;
